import { renderSlot as _renderSlot, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, Teleport as _Teleport, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: "tooltip-trigger",
    ref: "trigger",
    onMouseenter: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.showTooltip && _ctx.showTooltip(...args))),
    onMouseleave: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.hideTooltip && _ctx.hideTooltip(...args)))
  }, [
    _renderSlot(_ctx.$slots, "default", {}, undefined, true),
    (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
      _createVNode(_Transition, { name: "fade" }, {
        default: _withCtx(() => [
          (_ctx.visible)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: "tooltip-content",
                style: _normalizeStyle(_ctx.tooltipStyles),
                ref: "tooltip"
              }, [
                (_ctx.$slots.content)
                  ? _renderSlot(_ctx.$slots, "content", { key: 0 }, undefined, true)
                  : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      _createTextVNode(_toDisplayString(_ctx.text), 1)
                    ], 64))
              ], 4))
            : _createCommentVNode("", true)
        ]),
        _: 3
      })
    ]))
  ], 544))
}